import React, { useEffect, useState } from "react";
import Breadcrumb from "./Breadcrumb";
import Profilecontent from "./Profilecontent";
import Pendingorder from "./Pendingorder";
import Pastorder from "./Pastorder";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Tab, Nav } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import Cancelledorder from "./Cancelledorder";
import Readytoshiporder from "./Readytoshiporder";
import Shippedorder from "./Shippedorder";

export const Content = (props) => {
  const authPermission = localStorage.getItem("PermissionDetails");
    const [mTabsHide, setHideMTabs] = useState(true);
    const [tabsHide, setHideTabs] = useState(true);
    const [pendingOrderCount, setPendingOrderCount] = useState(0);
    const [readyToShipOrderCount, setReadyToShipOrderCount] = useState(0);
    const [shippedOrderCount, setShippedOrderCount] = useState(0);
    const [completedOrderCount, setCompletedOrderCount] = useState(0);
    const [cancelledOrderCount, setCancelledOrderCount] = useState(0);
  
    useEffect(() => {
      JSON.parse(authPermission).forEach(function (loca) {
        if (
          loca.access_level.access_level == "SUPER_ADMIN"
        ) {
          setHideMTabs(false);
        }

        if (
          loca.access_level.access_level == "ADMIN"
        ) {
          setHideTabs(false);
        }
      });
    }, [authPermission]);

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
        </div>
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Customer Details</h6>
            </div>
            <div hidden={mTabsHide} className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13" className="d-flex justify-content-center">Customer Profile<div className="text-white rounded mx-3 px-2 align-content-center"> </div></Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab14" className="d-flex justify-content-center">Pending Orders <div className="text-white bg-black rounded mx-3 px-2 align-content-center"> {pendingOrderCount} </div></Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab15" className="d-flex justify-content-center">Ready To Ship Orders <div className="text-white bg-black rounded mx-3 px-2 align-content-center"> {readyToShipOrderCount} </div></Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab16" className="d-flex justify-content-center">Shipped Orders <div className="text-white bg-black rounded mx-3 px-2 align-content-center"> {shippedOrderCount} </div></Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab17" className="d-flex justify-content-center">Completed Orders <div className="text-white bg-black rounded mx-3 px-2 align-content-center"> {completedOrderCount} </div></Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab18" className="d-flex justify-content-center">Cancelled Orders <div className="text-white bg-black rounded mx-3 px-2 align-content-center"> {cancelledOrderCount} </div></Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <Profilecontent />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab14">
                    <Pendingorder setPendingOrderCount={setPendingOrderCount} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab15">
                    <Readytoshiporder setReadyToShipOrderCount={setReadyToShipOrderCount} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab16">
                    <Shippedorder setShippedOrderCount={setShippedOrderCount} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab17">
                    <Pastorder setCompletedOrderCount={setCompletedOrderCount} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab18">
                    <Cancelledorder setCancelledOrderCount={setCancelledOrderCount} />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
            <div hidden={tabsHide} className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13">Customer Profile</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <Profilecontent />
                  </Tab.Pane>
                  {/* <Tab.Pane eventKey="tab16">
                    <Cancelledorder />
                  </Tab.Pane> */}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
